'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');
const get = require('lodash.get');

function ViewInvoiceLink({user, viewer, itemId, onClick, children, className}) {
    if (!get(user, 'canSeeInvoice') || get(viewer, 'transactions.totalResults')) {
        return null;
    }
    return (
        <a
            href={`/my/orders/invoice/id-${itemId}/`}
            target="_blank"
            className={className}
            onClick={onClick}
        >
            {children}
        </a>
    );
}

ViewInvoiceLink.defaultProps = {
    onClick: () => {}
};

ViewInvoiceLink.propTypes = {
    itemId: PropTypes.string.isRequired,
    viewer: PropTypes.object,
    user: PropTypes.object,
    onClick: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string
};

module.exports = Relay.createContainer(ViewInvoiceLink, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null
    },
    fragments: {
        viewer: () => Relay.QL`
            fragment on Viewer {
                transactions(viewName: "buyer.buyerPreInvoiceFilter", buyerId: $userId, itemId: $itemId) @include(if: $hasUserId) {
                    totalResults
                }
            }
        `,
        user: () => Relay.QL`
            fragment on User {
                canSeeInvoice: hasPermission(name: "B_INVOICE")
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Invoice/ViewInvoiceLink.jsx